import { api } from "../../lib";

export interface Group {
  id: string;
  name: string;
  description: string | null;
  isActive: boolean;
  createdAt: string;
}

export interface CreateGroupInput {
  name: string;
  description?: string;
  isActive?: boolean;
}

export interface UpdateGroupInput extends Partial<CreateGroupInput> {
  id: string;
}

export const groupsService = {
  getAll: async () => {
    return api.get<Group[]>("/admin/groups");
  },

  getById: async (id: string) => {
    return api.get<Group>(`/admin/groups/${id}`);
  },

  create: async (input: CreateGroupInput) => {
    return api.post<Group>("/admin/groups", {
      name: input.name,
      description: input.description,
      isActive: input.isActive ?? true,
    });
  },

  update: async (input: UpdateGroupInput) => {
    const { id, ...updates } = input;
    return api.put<Group>(`/admin/groups/${id}`, updates);
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/groups/${id}`);
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.put<Group>(`/admin/groups/${id}`, { isActive });
  },
};
